import type { CheckoutSession } from "@/types";

import { trackSessionEvent } from "./analytics-helpers";

export type DeclineUiPageShownEventData = {
  decline_reason: string;
  order_amount: number | null;
  recommended_limit: number | null;
  breakdown_shown: string[];
  pay_in_full_shown: boolean;
  checkout_id: string;
  order_id: string;
};

export function emitDeclineUiPageShownTracking(
  session: CheckoutSession,
  eventData: DeclineUiPageShownEventData,
): void {
  trackSessionEvent("decline_ui_page_shown", session, eventData);
}

export function emitDeclineUiBackToMerchantClickedTracking(
  session: CheckoutSession,
): void {
  trackSessionEvent("decline_ui_back_to_merchant_clicked", session, {
    checkout_id: session.id,
    order_id: session.order?.id ?? "",
  });
}

export function emitDeclineUiActionClickedTracking(
  session: CheckoutSession,
  actionType: string,
): void {
  trackSessionEvent("decline_ui_action_clicked", session, {
    action_type: actionType,
    decline_reason: session.creditDeclineInfo?.declineCode ?? "",
    checkout_id: session.id,
    order_id: session.order?.id ?? "",
  });
}
